export const attachAccessToken = (config, storage = localStorage) => {
  const token = storage.getItem('accessToken')

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
}

export const requestTicket = (client, method, data, configs = {}) => {
  const path = `/ticket${configs.urlAppend || ''}`
  const requestConfig = typeof FormData !== 'undefined' && data instanceof FormData
    ? { headers: { 'Content-Type': 'multipart/form-data' } }
    : undefined

  switch (method) {
    case 'get':
      return client.get(path)
    case 'post':
      return client.post(path, data, requestConfig)
    case 'put':
      return client.put(path, data, requestConfig)
    case 'patch':
      return client.patch(path, data, requestConfig)
    case 'delete':
      return client.delete(path, { data })
    default:
      throw new Error(`Ticket method ${method} not supported`)
  }
}
